export * from './set-registering.action';
